//@flow
import React, { Component } from 'react';
import {
  CustomCsvImg,
  CustomCsvh5,
  CustomCsvA
} from './CommissionPaidShowStyles';
import downloadFileImg from '../../../assets/images/download-file.png';
import { Default } from '../../../components/Responsive';

type Props = {
  color: string,
  downloadCsv: () => void
};
export default class CustomCsv extends Component<Props> {
  render() {
    return (
      <CustomCsvA onClick={() => this.props.downloadCsv()} noFlex>
        <Default>
          <CustomCsvImg src={downloadFileImg} alt="" />
        </Default>
        <CustomCsvh5 color={this.props.color}>Download CSV</CustomCsvh5>
      </CustomCsvA>
    );
  }
}
